import { FailConfirmModal } from './FailConfirmModal';

// The prompts that fire ON COMPLETING A SET, in one place.
//
// They are a different family from LoggerModals: those are pickers and config
// sheets the athlete opens on purpose, driven by open/close pairs owned in
// useLoggerScreen. This one is raised BY the commit itself, owns its state
// inside useTimelineLogger (useFailConfirm), and decides what gets written
// about the set that was just closed.
//
// One place on purpose: two uncoordinated <Modal>s on one gesture is a bug
// this codebase has already shipped (useEffortCommit, 2026-07-06). The AMRAP
// question that used to live here is gone (#539): the effort band is the
// outcome, so a prompt added here later gets a visible order, not a race.

type Props = {
  failPrompt: { attempted: number } | null;
  onConfirmFail: (savedReps: number) => void;
  onCancelFail: () => void;
};

export function LoggerCommitPrompts({
  failPrompt,
  onConfirmFail,
  onCancelFail,
}: Props) {
  if (!failPrompt) return null;
  return (
    <FailConfirmModal
      attempted={failPrompt.attempted}
      onConfirm={onConfirmFail}
      onCancel={onCancelFail}
    />
  );
}
